// Header.tsx
import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PublicIcon from '@mui/icons-material/Public';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

import type { SUPPORTS } from "../interface/interface";

interface HeaderProps {
    tickets: SUPPORTS[];
}



const statusColors: Record<string, { bg: string; color: string; label: string }> = {
    'OPEN': { bg: '#E0E7FF', color: '#3730A3', label: 'ABIERTO' },
    'CLOSE': { bg: '#E5E7EB', color: '#6B7280', label: 'FINALIZADO' },
    'PROCESS': { bg: '#DBEAFE', color: '#1E40AF', label: 'EN PROCESO' },
    'VALIDATION': { bg: '#FEF9C3', color: '#92400E', label: 'EN VALIDACIÓN' },
};



const Header: React.FC<HeaderProps> = ({ tickets }) => {
    const openTickets = tickets.filter(t => t.status === 'OPEN').length;
    const closedTickets = tickets.filter(t => t.status === 'CLOSE').length;
    const respondedTickets = tickets.filter(t => t.status === 'PROCESS').length;
    const validationTickets = tickets.filter(t => t.status === 'VALIDATION').length;

    const stats = [
        {
            count: closedTickets,
            label: 'TICKETS FINALIZADOS',
            icon: <MailOutlineIcon sx={{ color: 'black' }} />,
            bg: '#ebe8e8'
        },
        {
            count: openTickets,
            label: 'TICKETS ABIERTOS',
            icon: <PublicIcon sx={{ color: '#3B82F6' }} />,
            bg: '#DBEAFE'
        },
        {
            count: respondedTickets,
            label: 'TICKETS EN PROCESO',
            icon: <ChatBubbleOutlineIcon sx={{ color: 'black' }} />,
            bg: '#e8e4f2'
        },
        {
            count: validationTickets,
            label: 'TICKETS EN ESPERA DE VALIDACION',
            icon: <ChatBubbleOutlineIcon sx={{ color: '#92400E' }} />,
            bg: '#FEF9C3'
        }
    ];


    

    return (
        <Grid container spacing={2}>
            {stats.map((item, index) => (
                <Grid xs={12} sm={6} md={3} key={index}>
                    <Paper
                        elevation={0}
                        sx={{
                            display: 'flex',
                            borderRadius: 2,
                            overflow: 'hidden',
                            backgroundColor: '#fff',
                            border: '1px solid #E5E7EB',
                            minHeight: 80
                        }}
                    >
                        <Box
                            sx={{
                                flex: '0 0 20%',
                                backgroundColor: item.bg,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {item.icon}
                        </Box>

                        <Box
                            sx={{
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                pl: 2
                            }}
                        >
                            <Typography variant="h6" fontWeight="bold" color="#111827">
                                {item.count}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{
                                    color: '#6B7280',
                                    fontWeight: 500,
                                    fontSize: '0.75rem'
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
};

export default Header;
